// extracted by mini-css-extract-plugin
module.exports = {"outerBox":"TimeDuration__outerBox__+Zb0X"};